// External libraries
import React from 'react';
import { func, string } from 'prop-types';
import styled from '@emotion/styled';

// Internal Modules
import { TEXT_COLOR } from '@/styles';

const AccessibilityText = styled.span`
  left: -9999px;
  opacity: 0;
  position: absolute;
`;

const StyledLink = styled.a`
  text-decoration: none;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;

const StyledText = styled.p`
  color: ${TEXT_COLOR};
  font-size: 13px;
  line-height: 1.38;
`;

const TermsLink = ({ clickHandler, href, text }) => (
  <StyledLink
    href={href}
    onClick={clickHandler}
    rel="noopener noreferrer"
    target="_blank"
  >
    {text}
  </StyledLink>
);

TermsLink.propTypes = {
  clickHandler: func,
  href: string.isRequired,
  text: string.isRequired,
};

export { AccessibilityText, StyledLink, StyledText, TermsLink };
